import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { OrganizationLevelService } from "src/app/services/organizationLevel.service";
import { OrganizationLevel } from "src/app/models/organizationLevel.model";
import { Lookup } from "src/app/models/lookup.model";
import { toOrganizationTree } from "src/app/_helpers/org-tree-helper";

export interface OrganizationLevelsData {
    flat: Lookup[];
    hierarchical: OrganizationLevel[];
}

@Injectable({
    providedIn: "root"
})
export class OrganizationLevelShareService {
    constructor(private organizationLevelService: OrganizationLevelService) { }

    loadOrganizationLevels(): Observable<OrganizationLevelsData> {
        return this.organizationLevelService.getAll().pipe(
            map(levels => ({
                flat: levels,
                hierarchical: toOrganizationTree(levels)
            }))
        );
    }

    handleShareToggle(isShared: boolean, currentOrgLevelId?: string | null): { orgLevelId: string | null } {
        return { orgLevelId: isShared ? currentOrgLevelId ?? null : null };
    }
}
